import {createActions, createReducer} from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import {getDefaultPath} from '../../helpers/urlSync';
import {getView} from '../../helpers/utility';

const preKeys = getDefaultPath();
const tag = '[APP_REDUX]';

const functionDefinitions = {
    startup: null,
    collapseChange: null,
    collapseOpenDrawer: null,
    toggleAll: [
        'width', 'height'
    ],
    changeOpenKeys: ['openKeys'],
    changeCurrent: ['current']
};


const {Types, Creators} = createActions(functionDefinitions);
export const AppReduxTypes = Types;
export default Creators;

export const AppInitState = {
    collapsed: window.innerWidth <= 1220,
    view: getView(window.innerWidth),
    height: (window as any).height,
    openDrawer: false,
    openKeys: preKeys,
    current: preKeys
};

export const INITIAL_STATE = Immutable(AppInitState);

export const startup = (state) => {
    console.log(`${tag} Startup caught in sagaAuthRedux/startup function`);
    return state.merge(AppInitState);
};
export const collapseChange = (state) => {
    return state.merge({
        collapsed: !state.collapsed
    });
};
export const collapseOpenDrawer = (state)  => {
    return state.merge({
        openDrawer: !state.openDrawer
    });
};
export const toggleAll = (state, action) => {
    const view = getView(action.width);
    if (state.view !== view || state.height !== action.height) {
        const collapsed = view !== 'DesktopView';
        const height = action.height
            ? action.height
            : state.height;
        return state.merge({collapsed, height, view});
    }
    return state;
};
export const changeOpenKeys = (state, action) => {
    return state.merge({openKeys: action.openKeys});
};
export const changeCurrent = (state, action) => {
    return state.merge({current: action.current});
};

export const reducer = createReducer(INITIAL_STATE, {
    [Types.STARTUP]: startup,
    [Types.COLLAPSE_CHANGE]: collapseChange,
    [Types.COLLAPSE_OPEN_DRAWER]: collapseOpenDrawer,
    [Types.TOGGLE_ALL]: toggleAll,
    [Types.CHANGE_OPEN_KEYS]: changeOpenKeys,
    [Types.CHANGE_CURRENT]: changeCurrent
});



// WEBPACK FOOTER //
// ./src/redux/app/appRedux.ts